// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_SHz","cls2":"ResearchInterestDirectorySearch-cls2_Ac_ ResearchInterestDirectorySearch-cls1_SHz"};